import { completed } from "@/mocks/anime";
import SectionHeading from "./SectionHeading";

export default function Completed() {
  return (
    <section id="completed" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          eyebrow="完结番合集"
          title="追更断档？来补一份完结番单"
          desc="故事完整、集数固定，周末一口气刷完刚刚好。每部都标注了集数与风格，帮你按心情选番，不怕烂尾也不用等更新。"
        />

        <div className="space-y-4">
          {completed.map((item, i) => (
            <article
              key={item.id}
              className="group flex flex-col gap-4 overflow-hidden rounded-lg border border-background-200 bg-background-50 p-3 transition-all hover:border-accent-200 sm:flex-row sm:p-4 md:p-5"
            >
              <div className="relative h-44 w-full shrink-0 overflow-hidden rounded-md bg-background-100 sm:h-40 sm:w-28 md:w-32">
                <img
                  src={item.image}
                  alt={`完结番：${item.title} 剧照`}
                  title={`${item.title} - 完结番合集`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-2 top-2 rounded-full bg-accent-500 px-2 py-0.5 text-xs font-bold text-background-50">
                  {i + 1}
                </span>
              </div>
              <div className="flex flex-1 flex-col">
                <div className="flex flex-wrap items-center gap-2">
                  <h4 className="font-heading text-lg text-foreground-950 group-hover:text-primary-600 transition-colors">
                    {item.title}
                  </h4>
                  <span className="inline-flex items-center gap-1 rounded-full bg-primary-100 px-2 py-0.5 text-xs font-bold text-primary-700">
                    <i className="ri-star-fill text-amber-500" />
                    {item.score.toFixed(1)}
                  </span>
                </div>
                <div className="mt-2 flex flex-wrap gap-1.5">
                  {item.tags.map((tag) => (
                    <span key={tag} className="rounded-full bg-secondary-100 px-2 py-0.5 text-xs text-secondary-900">
                      {tag}
                    </span>
                  ))}
                </div>
                <p className="mt-3 line-clamp-2 text-sm leading-6 text-foreground-600">{item.synopsis}</p>
                <div className="mt-3 flex items-center gap-4 text-xs text-foreground-500">
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-film-line" />
                    {item.episodes} 集
                  </span>
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-calendar-line" />
                    {item.year} 完结
                  </span>
                  <span className="inline-flex items-center gap-1 text-accent-700">
                    <i className="ri-check-double-line" />
                    可一口气补完
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}